import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { ModalController } from "@ionic/angular/standalone";
import { TranslateModule } from "@ngx-translate/core";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { ImagePipe } from "src/app/pipes/image/image";
import { EventoProvider } from "src/app/services/evento/evento";

@Component({
  selector: "app-evento-detalhes-inscricao",
  templateUrl: "./evento-detalhes-inscricao.page.html",
  styleUrls: ["./evento-detalhes-inscricao.page.scss"],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule, ImagePipe, TranslateModule, LoadingSpinnerComponent],
})
export class EventoDetalhesInscricaoPage implements OnInit {
  @Input() participante!: any;

  loaded = false;
  idPessoa!: string;
  idEvento!: string;
  idEventoInscricao!: string;
  pessoa: any;
  questionario: any;

  constructor(public modalCtrl: ModalController, public eventoProvider: EventoProvider) {}

  ngOnInit() {
    const { idPessoa, idEvento, idEventoInscricao } = this.participante;

    this.idPessoa = idPessoa;
    this.idEvento = idEvento;
    this.idEventoInscricao = idEventoInscricao;

    this.loadinformation();

    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  loadinformation() {
    this.eventoProvider.getInfoAdicionais(this.idPessoa, this.idEvento, this.idEventoInscricao).subscribe((data) => {
      this.pessoa = data.pessoa;
      this.questionario = data.questionario;
    });
  }

  abrirContato(contato: any) {
    if(!contato) return;
    const telefone = contato.replace(/\D/g, "");
    const url = `tel:+${telefone}`;
    window.open(url);
  }

  abrirEmail(email: any) {
    if(!email) return;
    const urlEmail = `mailto:${email}`;
    window.open(urlEmail);
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
